const SK_GLOBAL_PLAN_KEY = 'sk_global_plan';

const STARTER_PLAN = 'starter';

function getPricingPlan() {
  const pricingPlan = window[SK_GLOBAL_PLAN_KEY];
  return pricingPlan || '';
}

function setPricingPlan(pricingPlan = '') {
  window[SK_GLOBAL_PLAN_KEY] = pricingPlan;
}

export default {
  getPricingPlan,
  setPricingPlan,
  STARTER_PLAN
};
